import React from 'react';
import {Switch, Redirect, Route} from 'react-router-dom';
import LoginPage from '../LoginPage';
import Desk from '../Desk';
import NotificationsModal from '../../components/NotificationsModal';
import styles from './style.css';

function App() {
    const userAuthenticated = () => !!localStorage.getItem('token');
    return (
        <div className={styles.container}>
            <Switch>
                <Route exact path={'/'}
                       render={() =>
                         <Redirect to={'/agents'} />} />
                <Route path={'/login'}
                       render={() => userAuthenticated()
                         ? <Redirect to={'/agents'} />
                         : <LoginPage/>} />
                <Route path={['/agents', '/kpi']}
                       render={() => userAuthenticated()
                         ? <Desk/>
                         : <Redirect to={'/login'} />} />
                <Redirect to={'/'}/>
            </Switch>
            <NotificationsModal />
        </div>

    );
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App/index.js